var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://elite-api.thriftyspends.com';
    service.VP_URL = 'https://verifyme.elitefundusa.com/loan-application-status';
    service.BACK_URL = 'https://elitefundusa.com';
    
} else {
    service.API_URL = "http://192.168.29.124:5002";
      service.VP_URL = 'http://192.168.29.124:3002/loan-application-status';
    service.BACK_URL = 'http://192.168.29.124:3002';
}

export default service;
